import { useEffect, useState } from "react";

import { getConfigs } from "app/utils/configs";
import { isHttpUrl } from "app/utils/url";

export function useCubejsConfig(): string | null {
  const [apiUrl, setApiUrl] = useState<string | null>(null);

  useEffect(() => {
    async function fetchConfig() {
      const configs = await getConfigs();

      const url = configs.cube?.url;
      if (!url) {
        // No cube configured (e.g. local-dev without `just local-cube`); leave
        // the URL unset so dashboards stay inert rather than erroring.
        return;
      }
      if (isHttpUrl(url)) {
        // Absolute URL, which is what every deployment publishes: derive the ws
        // scheme from it -- ws:// for the plain-HTTP local cube, wss:// for TLS.
        const u = new URL(url);
        const scheme = u.protocol === "https:" ? "wss" : "ws";
        setApiUrl(`${scheme}://${u.host}/cubejs-api/v1`);
      } else {
        // Path-relative, and nothing else: `getConfigs` hands every service URL
        // over in absolute or path-relative form, so a bare domain -- which
        // cube, alone, has historically published -- cannot reach this branch
        // and be read as a path. Connect back to the page's own host.
        const scheme = window.location.protocol === "https:" ? "wss" : "ws";
        setApiUrl(`${scheme}://${window.location.host}${url}/cubejs-api/v1`);
      }
    }

    if (!apiUrl) {
      fetchConfig();
    }
  }, [apiUrl, setApiUrl]);

  return apiUrl;
}
